module.exports = __webpack_public_path__ + "static/media/timeline-icon-active.75b43962.svg";